import { useEffect, useState } from 'react';

/**
 * True below the lg breakpoint (Tailwind's 1024px). For inline-style
 * animations and numeric props that CSS prefixes can't drive.
 * Updates live on resize / device rotation.
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia('(max-width: 1023px)').matches,
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
